<template>
  <div :class="{ with_title: image && image.title }" class="h-100">
    <div v-if="mode == 'selectimage'" class="h-100 d-flex justify-content-center align-items-center">
      <button title="Upload" @click="openModal" style="border: none;background: white;">
        <font-awesome-icon icon="image"/>
      </button>

      <!-- ADD IMAGE MODAL START HERE -->
      <b-modal  v-model="docModal"  title="Image Uploading" @ok="submitFile($event)">
        <b-form-group label="Name:*" :invalid-feedback="invalidReportNameFeedback1"  :state="isReportNameStateValid1">
          <b-form-file
              v-model="file1"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here...">
          </b-form-file>
        </b-form-group>
        <div class="mt-3">Selected file: {{ this.file1 ? this.file1.name : '' }}</div>
      </b-modal>
      <!-- ADD IMAGE MODAL ENDS HERE -->
    </div>

    <!-- SHOWING IMAGE CONTAINER STARTS HERE -->
    <div v-if="mode == 'image'" class="image_container p-2">
      <div class="action_button_container">
        <b-button title="bottomTitle" v-if="editMode" class="p-0 color_black mb-0 btn p-0 mr-2 pt-1" @click="addBottomLabel" variant="default" >
          <font-awesome-icon style="color:black" icon="comment-alt" />
        </b-button>
        <b-button title="Title" v-if="editMode" class="p-0 color_black mb-0 btn p-0 mr-2 pt-1" @click="updateSectionTitle" variant="default" >
          <font-awesome-icon icon="font" />
        </b-button>
        <button title="Update" v-if="editMode" @click="updateModal"  class="p-0 color_black mb-0 btn p-0 mr-2 pt-1">
          <font-awesome-icon style="color:black" icon="edit"/> </button>
        <b-button title="Delete" v-if="editMode" class="p-0 color_black mb-0 btn p-0 mr-2 pt-1"  @click="handleConfirmDelete"  variant="default" >
          <font-awesome-icon icon="trash-alt" />
        </b-button>
      </div>

      <sectionTitleAndLabel mode="title"  v-if="image.title" :text="image.title" :centerAlign="false"></sectionTitleAndLabel>
      <div class="image-container h-100">
        <img :src="image.image" class="report-image" >
      </div>
      <sectionTitleAndLabel mode="caption" v-if="image.bottomLabel" :text="image.bottomLabel" :centerAlign="true"></sectionTitleAndLabel>

    </div>
    <!-- SHOWING IMAGE CONTAINER ENDS HERE -->

    <!-- UPDATE FILE MODAL STARTS HERE -->
    <b-modal  v-model="UpModal"  title="Image Updating" @ok="updatefile($event)">
      <b-form-group label="Name:*" :invalid-feedback="invalidReportNameFeedback2"  :state="isReportNameStateValid2">
        <b-form-file
          v-model="file2"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here...">
        </b-form-file>
      </b-form-group>
      <div class="mt-3">Selected file: {{ this.file2 ? this.file2.name : '' }}</div>
    </b-modal>
    <!-- UPDATE FILE MODAL ENDS HERE -->

    <!-- DELETE IMAGE MODAL STARTS HERE -->
    <b-modal v-model="confirmDeletion" size="md" scrollable  @ok="handleDel()">
      <div class="p-5">
        <h5>
          Sei sicuro di eliminarlo?
        </h5>
      </div>
    </b-modal>
    <!-- DELETE IMAGE MODAL ENDS HERE -->

    <!-- ADD IMAGE TITLE STARTS HERE -->
   <b-modal cancel-title="Annulla" v-model="addTitleModal"  hide-header  :body-class="'choose_chartmodal'" scrollable :header-bg-variant="'light'" @ok="addTitleToReportPageOrSection" >
      <div class="p-4">
        <h3>
          Titolo scheda
        </h3>
        <b-form ref="titleForm" class="my-5">
          <b-form-group >
            <b-form-input
              v-model="titleNameForPageAndBlock"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>
    <!-- ADD IMAGE TITLE ENDS HERE -->

    <!-- ADD IMAGE BOTTOM TITLE START HERE -->
    <b-modal cancel-title="Annulla" v-model="addBottomTitleModal"  hide-header  :body-class="'choose_chartmodal'" scrollable :header-bg-variant="'light'" @ok="addBottomLabelToSection">
      <div class="p-4">
        <h3>
          Didascalia
        </h3>
        <b-form ref="titleForm" class="my-5">
          <b-form-group >
            <b-form-input
              v-model="bottomLabelForChart"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>
    <!-- ADD IMAGE BOTTOM TITLE ENDS HERE -->
  </div>
</template>

<script>

  import sectionTitleAndLabel from './sectionTitleAndLabel.vue';
  import VueResizable from 'vue-resizable';
  import debounce from "lodash/debounce";


  export default
  {
    name : 'imageBox',
    components:{
      sectionTitleAndLabel,
      VueResizable
    },
    props:{
      mode:{
        required: true,
        type:String
      },
      image:{
        required: false
      },
      loc:{
        required:true,
        type: Object
      },
      selectedReport:{
        required:true,
        type: Object
      },
      editMode:{
        required:true,
        type: Boolean
      },
    },
    data()
    {
      return {
        editClass:'',
        confirmDeletion:false,
        imageUrl:'',
        imageID:'',
        userName:'',
        titleNameForPageAndBlock : '',
        addTitleModal : false,
        selectedRowColumn: null,
        uniqueID:null,
        bottomLabelForChart: '',
        addBottomTitleModal: false,
        docModal:false,
        UpModal:false,
        file1 :null,
        file2:null,
        newReportFormSubmitted1:false,
        newReportFormSubmitted2:false,
        updateImage:true,
        file:'',
        fileType:'',
        validImageTypes:'',
        left: 0,
        top: 0,
        height: `calc( 100% - 0px)`,
        width: `calc( 100% - 5px)`,
        imageDimensions: {}
      }
    },

    created(){
      console.log("Image box created")
      if(this.image && this.image.imageDimensions){
        this.height = this.image.imageDimensions.height;
        this.width = this.image.imageDimensions.width;
      }
    },
 watch:{
   editMode()
   {
     if(this.editMode)
     {
       this.editClass= "falseBoxImage";
     }
     else{
       this.editClass="boxImage";
     }

   }
 },
    methods:{
      eHandler(data) {
        this.width = data.width;
        this.height = data.height;
        this.left = data.left;
        this.top = data.top;
        this.imageDimensions = {
          height: this.height,
          width: this.width
        }
      },
      handleConfirmDelete() {
        this.confirmDeletion = true;
      },
      openModal() {
        this.newReportFormSubmitted1 = false;
        this.docModal = true;
      },
      updateModal() {
        this.newReportFormSubmitted2 = false;
        this.UpModal = true;
      },
      imageUpload() {
        var today = new Date();
        var date = today.getTime();
        this.$store.commit("loading");
        let report = _.cloneDeep(this.selectedReport);
        let data = {
          ...this.loc
        };
        let sectionIndex = report.data.pages[data.pageIndex].sections.findIndex(ele => {
          return ele.loc.colIndex == data.colIndex && data.rowIndex == ele.loc.rowIndex

        });
        if (sectionIndex < 0) {
          report.data.pages[data.pageIndex].sections.push({
            image: this.imageUrl + '?time=' + date,
            sectionType: "image",
            loc: this.loc,
            imageId: this.imageID,
          })
        } else {
          report.data.pages[data.pageIndex].sections[sectionIndex].image = this.imageUrl + '?time=' + date;
          report.data.pages[data.pageIndex].sections[sectionIndex].imageId = this.imageID;
        }
        this.$store.dispatch('report/updateReportBuilder', report);
        this.$store.commit("stopLoading");
      },
      async handleDel() {
        this.$store.commit("loading");
        let report = _.cloneDeep(this.selectedReport);
        let data = {
          ...this.loc
        };
        let sectionIndex = report.data.pages[data.pageIndex].sections.findIndex(ele => {
          return ele.loc.colIndex == data.colIndex && data.rowIndex == ele.loc.rowIndex

        });
        report.data.pages[data.pageIndex].sections.splice(sectionIndex, 1);
        await this.$store.dispatch('report/updateReportBuilder', report);
        let deletedImageResponse = await this.$store.dispatch('report/deleteImage', this.image.imageId);
        this.$store.commit("stopLoading");
      },
      updateSectionTitle() {
        this.addTitleModal = true;
        let data = {
          ...this.loc
        };
        let colIndex = data.colIndex;
        let rowIndex = data.rowIndex;
        let pageIndex = data.pageIndex;
        this.selectedRowColumn = {
          colIndex,
          rowIndex,
          pageIndex,
          titleType: 'section'
        };
        let report = _.cloneDeep(this.selectedReport);
        let sectionIndex = report.data.pages[data.pageIndex].sections.findIndex(ele => {
          return ele.loc.colIndex == data.colIndex && data.rowIndex == ele.loc.rowIndex
        });
        let sectionTitle = report.data.pages[pageIndex].sections[sectionIndex].title ? report.data.pages[pageIndex].sections[sectionIndex].title : '';
        this.titleNameForPageAndBlock = sectionTitle;
      },

      addBottomLabel() {
        this.addBottomTitleModal = true;
        let data = {
          ...this.loc
        };
        let colIndex = data.colIndex;
        let rowIndex = data.rowIndex;
        let pageIndex = data.pageIndex;
        this.selectedRowColumn = {
          colIndex,
          rowIndex,
          pageIndex,
          titleType: 'section'
        };
        let report = _.cloneDeep(this.selectedReport);
        let sectionIndex = report.data.pages[pageIndex].sections.findIndex(ele => {
          return ele.loc.colIndex == colIndex && rowIndex == ele.loc.rowIndex
        });
        let bottomLabel = report.data.pages[pageIndex].sections[sectionIndex].bottomLabel ? report.data.pages[pageIndex].sections[sectionIndex].bottomLabel : '';
        this.bottomLabelForChart = bottomLabel;
        this.height = `calc( 100% - 0px)`;
         this.width = `calc( 100% - 5px)`;
      },
      async addTitleToReportPageOrSection() {
        this.$store.commit("loading");
        let {
          pageIndex,
          rowIndex,
          colIndex,
          titleType
        } = this.selectedRowColumn;
        let report = _.cloneDeep(this.selectedReport);
        let sectionIndex = report.data.pages[pageIndex].sections.findIndex(ele => {
          return ele.loc.colIndex == colIndex && rowIndex == ele.loc.rowIndex
        });
        report.data.pages[pageIndex].sections[sectionIndex].title = this.titleNameForPageAndBlock;
        await this.$store.dispatch('report/updateReportBuilder', report);
        this.$store.commit("stopLoading");
        this.addTitleModal = false;
      },

      async addBottomLabelToSection() {
        this.$store.commit("loading");

        let {
          pageIndex,
          rowIndex,
          colIndex,
          titleType
        } = this.selectedRowColumn;
        let report = _.cloneDeep(this.selectedReport);
        let sectionIndex = report.data.pages[pageIndex].sections.findIndex(ele => {
          return ele.loc.colIndex == colIndex && rowIndex == ele.loc.rowIndex
        });
        report.data.pages[pageIndex].sections[sectionIndex].bottomLabel = this.bottomLabelForChart;

        await this.$store.dispatch('report/updateReportBuilder', report);
        this.$store.commit("stopLoading");
        this.addTitleModal = false;
      },


      async submitFile(event) {
        event.preventDefault();
        this.newReportFormSubmitted1 = true;

        this.file = this.file1;
        this.fileType = this.file['type'];
        this.validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
        if (!this.validImageTypes.includes(this.fileType)) {
          return;
        }
        let formData = new FormData();
        formData.append('file', this.file1);
        if (this.file1 == null) {
          return;
        }
        this.$store.commit("loading");
        this.imageUrl = await this.$store.dispatch('report/postImage', formData);
        this.imageID = this.imageUrl.substring(this.imageUrl.lastIndexOf('/') + 1)
        this.imageUpload();
        this.newReportFormSubmitted1 = false;
        this.$store.commit("stopLoading");
      },
      async updatefile(event) {
        event.preventDefault();
        this.newReportFormSubmitted2 = true;
        let formData = new FormData();
        formData.append('file', this.file2);
        if (this.file2 == null) {
          return;
        }

        this.file = this.file2;
        this.fileType = this.file['type'];
        this.validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
        if (!this.validImageTypes.includes(this.fileType)) {
          return;
        }
        let identity = this.image.imageId;
        this.$store.commit("loading");
        this.imageUrl = await this.$store.dispatch('report/updateImage', {
          formData,
          identity
        });
        this.imageID = this.imageUrl.substring(this.imageUrl.lastIndexOf('/') + 1)
        this.imageUpload();
        this.newReportFormSubmitted2 = false;
        this.UpModal = false;
        this.$store.commit("stopLoading");
      },
      async updateImageResizeSilently(){
         let data = {
          ...this.loc
        };
        let {
          pageIndex,
          rowIndex,
          colIndex,
        } = data;

        let report = _.cloneDeep(this.selectedReport);
        let sectionIndex = report.data.pages[pageIndex].sections.findIndex(ele => {
          return ele.loc.colIndex == colIndex && rowIndex == ele.loc.rowIndex
        });
        report.data.pages[pageIndex].sections[sectionIndex].imageDimensions = this.imageDimensions;

        await this.$store.dispatch('report/updateReportBuilderSilently', report);

      }
    },
    watch:{
      imageDimensions: {
        handler: debounce(async function Unnamed() {
          await this.updateImageResizeSilently();
        }, 1000),
        deep: true
      },
    },

    computed:{
      imageResizeHandlers() {
        return this.editMode ? ['r','b'] : []
      },
      calculateImageBoxHeight() {
        if(this.image.title && this.image.bottomLabel){
          return `calc( 100% - 48px)`
        } else if (!this.image.title && this.image.bottomLabel || this.image.title && !this.image.bottomLabel){
          return `calc(100% - 24px)`
        }
        return `calc( 100% - 0px)`
      },
      calculateImageWidth() {
        return this.width - 16 + 'px'
      },
      // ...mapGetters({
      //   editModeGetter: 'report/editMode',
      // }),

      // editModeStatus (){
      //   this.editMode = this.editModeGetter;
      //   return this.editModeGetter;
      // },
      invalidReportNameFeedback1() {

        if (this.file1==null) {
          return 'Please select any file.'
        }
        if (!this.validImageTypes.includes(this.fileType)) {
        return 'invalid file '
        }
        else{
          return null;
        }
      },

      isReportNameStateValid1(){

        if(!this.newReportFormSubmitted1){
          return null
        }

              if (!this.validImageTypes.includes(this.fileType)) {
              return false;
        }

        if((this.file1==null)){
          return false;
        }
        return true;
      },

      invalidReportNameFeedback2()
      {
          if (this.file2==null) {
          return 'Please select any file.'
        }
        if (!this.validImageTypes.includes(this.fileType)) {
        return 'invalid file '
        }

        else{
          return null;
        }
      },

      isReportNameStateValid2(){

        if(!this.newReportFormSubmitted2){
          return null
        }
            if (!this.validImageTypes.includes(this.fileType)) {
              return false;
        }

        if((this.file2==null)){
          return false;
        }
        return true;
      },
    }
  }

</script>

<style>
  .color_black {
    color: black;
  }

  .falseBoxImage{
    height: 80% !important;
    resize: both;
    max-width: 100%;
    overflow: hidden !important;
    max-height: 100%;
    max-height: 339px;
  }

  .falseBoxImage img {
    max-width: 100%;
    max-height: 339px;
  }

  .edit_delete_container {
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 100;
    padding-left: 7px;
    display: flex;
    background: rgba(240, 240, 240, .8);
  }

  .update-btn {
    border-style: hidden;
    background-color: transparent;
  }
  .report-image {
    object-fit:contain;
    height:100%;
    width:100%
  }
  .with_title .report-image {
    object-fit:contain;
    height:calc(100% - 30px);
    width:100%
  }
  .bg-class {
    position: relative;
    top: 0px;
    right: 0px;
    padding-left: 7px;
    display: flex;
  }

  .image_container {
    position: relative;
    height:100%;
  }

  .action_button_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 3px;
    right: 5px;
    z-index: 100;
    border: 1px solid #e2e2e2;
    background: rgba(240, 240, 240, .8);
  }

  .h-100{
    height:100%
  }

  .resizable-content {
    height: 100%;
    width: 100%;
  }

  .image_resizable_component .resizable-component > .resizable-r {
    background: #ababab !important;
    width: 13px !important;
  }
  .image_resizable_component .resizable-component > .resizable-b {
    background: #ababab !important;
    width: 100% !important;
    bottom: 0px!important;
    height: 13px !important;
    position: relative !important;

  }


  .image_resizable_component .resizable-component >.resizable-b::after, .image_resizable_component .resizable-component > .resizable-b::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: black;
    -webkit-transition: background-color .3s;
    transition: background-color .3s;
    transform: translateX(-50%);
    width: 30px;
    height: 1px;
}

  .image_resizable_component .resizable-component > .resizable-r::after, .image_resizable_component .resizable-component >  .resizable-r::before {
        content: "";
    position: absolute;
    top: 50%;
    left: 6px !important;
    background-color: black;
    /* transform: translateX(-66%); */
    width: 1px !important;
    height: 34px !important;
    transform: rotate(180deg) !important;
}


  .image_resizable_component .resizable-component > .resizable-b::before {
    margin-top: -2px!important;
  }

  .image_resizable_component  .resizable-component > .resizable-r::before {
    margin-left: -2px!important;
  }



</style>



// WEBPACK FOOTER //
// src/components/Reports/imageBox.vue